/**
* 左边菜单
*/
<template>
  <el-menu
    :collapse="collapsed"
    collapse-transition
    router
    :default-active="$route.path"
    unique-opened
    class="el-menu-vertical-demo"
    background-color="#fff"
    text-color="#303133"
    active-text-color="#2772c7"
  >
    <div class="logobox" :class="{ 'logobox--with-name': showBrandWithName }">
      <div v-if="showBrandWithName" class="brand-row">
        <img
          class="logoimg"
          :class="{ 'brand-favicon': isFaviconOnly }"
          :src="brandImageUrl"
          :alt="brand.systemName || ''"
        />
        <span class="system-name" :title="brand.systemName">{{ brand.systemName }}</span>
      </div>
      <template v-else>
        <img
          v-if="brandImageUrl"
          class="logoimg"
          :class="{ 'brand-favicon': isFaviconOnly }"
          :src="brandImageUrl"
          :alt="brand.systemName || ''"
        />
        <span
          v-else-if="brand.systemName"
          class="system-name system-name--only"
          :title="brand.systemName"
        >{{ brand.systemName }}</span>
      </template>
    </div>
    <el-menu-item
      v-for="menu in filteredMenuItems"
      :index="'/' + menu.url"
      :key="menu.menuid"
    >
      <i :class="menu.icon"></i>
      <span>{{ menu.menuname }}</span>
    </el-menu-item>
    <el-submenu
      v-for="menu in filteredSubmenus"
      :key="menu.menuid"
      :index="menu.menuname"
    >
      <template slot="title">
        <i :class="menu.icon"></i>
        <span>{{ menu.menuname }}</span>
      </template>
      <el-menu-item-group>
        <el-menu-item
          v-for="chmenu in menu.menus"
          :index="'/' + chmenu.url"
          :key="chmenu.menuid"
        >
          <i class="iconfont" :class="chmenu.icon"></i>
          <span>{{ chmenu.menuname }}</span>
        </el-menu-item>
      </el-menu-item-group>
    </el-submenu>
  </el-menu>
</template>
<script>
import { menu } from "../api/userMG";
export default {
  name: "leftnav",
  data() {
    return {
      activeRoute: "",
      collapsed: false,
      allmenu: [],
    };
  },
  // 创建完毕状态(里面是操作)
  created() {
    let user = JSON.parse(localStorage.getItem("user_info"));
    // 获取图形验证码
    let res = {
      success: true,
      data: [
        {
          menuid: 1,
          icon: "el-icon-s-home",
          menuname: "首页",
          url: "index/work",
          hasThird: null,
          menus: null,
        },
        {
          menuid: 2,
          icon: "el-icon-s-order",
          menuname: "用工中心",
          hasThird: null,
          url: null,
          menus: [
            {
              menuid: 21,
              icon: "",
              menuname: "任务列表",
              hasThird: "N",
              url: "task/taskList",
              menus: null,
            },
            {
              menuid: 22,
              icon: "",
              menuname: "用工结算单",
              hasThird: "N",
              url: "task/employmentStatement",
              menus: null,
            },
            {
              menuid: 23,
              icon: "",
              menuname: "用工结算明细",
              hasThird: "N",
              url: "task/employmentStatementDesc",
              menus: null,
            },
            {
              menuid: 24,
              icon: "",
              menuname: "自由职业者列表",
              hasThird: "N",
              url: "task/professionalList",
              menus: null,
            },
          ],
        },
        {
          menuid: 5,
          icon: "el-icon-s-check",
          menuname: "财务中心",
          hasThird: true,
          url: null,
          menus: [
            {
              menuid: 51,
              icon: "",
              menuname: "余额管理",
              hasThird: "N",
              url: "payCenter/balanceManage",
              menus: null,
            },
            {
              menuid: 52,
              icon: "",
              menuname: "充值记录",
              hasThird: "N",
              url: "payCenter/rechargeRecord",
              menus: [
                {
                  menuid: 52,
                  icon: "",
                  menuname: "开票申请",
                  hasThird: "N",
                  url: "payCenter/applybilling",
                  menus: null,
                },
              ],
            },
            {
              menuid: 53,
              icon: "",
              menuname: "开票记录",
              hasThird: "N",
              url: "payCenter/billingRecordList",
              menus: null,
            },
            {
              menuid: 55,
              icon: "",
              menuname: "电子回单",
              hasThird: "N",
              url: "payCenter/electronicReceipt",
              menus: null,
            },
          ],
        },
        {
          menuid: 7,
          icon: "el-icon-s-platform",
          menuname: "管理中心",
          hasThird: null,
          url: null,
          menus: [
            {
              menuid: 71,
              icon: "",
              menuname: "合同管理",
              hasThird: "N",
              url: "manageCenter/contractManage",
              menus: null,
            },
          ],
        },
        {
          menuid: 6,
          icon: "el-icon-menu",
          menuname: "数据中心",
          hasThird: null,
          url: null,
          menus: [
            {
              menuid: 61,
              icon: "",
              menuname: "自由职业者结算统计",
              hasThird: "N",
              url: "dataCenter/ReceivableTransactionStatistics",
              menus: null,
            },
            {
              menuid: 62,
              icon: "",
              menuname: "商户结算统计",
              hasThird: "N",
              url: "dataCenter/BusinessStatistics",
              menus: null,
            },
            {
              menuid: 63,
              icon: "",
              menuname: "批次明细交易信息查询",
              hasThird: "N",
              url: "dataCenter/batchmation",
              menus: null,
            },
          ],
        },
      ],
      msg: "success",
    };
    // 风控
    let riskContro = {
      success: true,
      data: [
        {
          menuid: 2,
          icon: "el-icon-s-order",
          menuname: "用工中心",
          hasThird: true,
          url: null,
          menus: [
            {
              menuid: 22,
              icon: "",
              menuname: "结算商户",
              hasThird: "N",
              url: "task/merchantList",
              menus: null,
            },
            {
              menuid: 23,
              icon: "",
              menuname: "用工结算明细",
              hasThird: "N",
              url: "task/employmentStatementDesc",
              menus: null,
            },
            {
              menuid: 24,
              icon: "",
              menuname: "自由职业者列表",
              hasThird: "N",
              url: "task/professionalList",
              menus: null,
            },
          ],
        },
        {
          menuid: 3,
          icon: "el-icon-s-check",
          menuname: "财务中心",
          hasThird: true,
          url: null,
          menus: [
            {
              menuid: 31,
              icon: "",
              menuname: "开票记录",
              hasThird: "N",
              url: "payCenter/invoiceRecord",
              menus: null,
            },
          ],
        },
        {
          menuid: 4,
          icon: "el-icon-menu",
          menuname: "数据中心",
          hasThird: true,
          url: null,
          menus: [
            {
              menuid: 42,
              icon: "",
              menuname: "商户结算统计",
              hasThird: "N",
              url: "dataCenter/BusinessStatistics",
              menus: null,
            },
            {
              menuid: 41,
              icon: "",
              menuname: "自由职业者结算统计",
              hasThird: "N",
              url: "dataCenter/ReceivableTransactionStatistics",
              menus: null,
            },
          ],
        },
      ],
      msg: "success",
    };

    // 代理
    let agent = {
      success: true,
      data: [
        {
          menuid: 1,
          icon: "el-icon-s-home",
          menuname: "首页",
          hasThird: null,
          url: "agent/index",
          menus: null,
        },
        {
          menuid: 2,
          icon: "el-icon-s-data",
          menuname: "数据中心",
          hasThird: null,
          url: null,
          menus: [
            {
              menuid: 21,
              icon: "",
              menuname: "批次统计",
              hasThird: "N",
              url: "agent/agentStatistics",
              menus: null,
            },
            {
              menuid: 22,
              icon: "",
              menuname: "商户统计",
              hasThird: "N",
              url: "agent/agentMerchantStatistics",
              menus: null,
            },
          ],
        },
        {
          menuid: 3,
          icon: "el-icon-s-custom",
          menuname: "商户管理",
          hasThird: null,
          url: null,
          menus: [
            {
              menuid: 31,
              icon: "",
              menuname: "商户列表",
              hasThird: "N",
              url: "agent/merchantList",
              menus: null,
            },
          ],
        },
        {
          menuid: 4,
          icon: "el-icon-s-cooperation",
          menuname: "档案中心",
          hasThird: null,
          url: null,
          menus: [
            {
              menuid: 41,
              icon: "",
              menuname: "档案列表",
              hasThird: "N",
              url: "agent/agentRate",
              menus: null,
            },
          ],
        },
        {
          menuid: 5,
          icon: "el-icon-s-check",
          menuname: "财务中心",
          hasThird: true,
          url: null,
          menus: [
            {
              menuid: 51,
              icon: "",
              menuname: "余额管理",
              hasThird: "N",
              url: "payCenter/balance",
              menus: null,
            },
            {
              menuid: 52,
              icon: "",
              menuname: "开票记录",
              hasThird: "N",
              url: "payCenter/invoiceRecord",
              menus: null,
            },
          ],
        },
      ],
      msg: "success",
    };

    // 销售
    let sales = {
      success: true,
      data: [
        {
          menuid: 1,
          icon: "el-icon-s-home",
          menuname: "首页",
          hasThird: null,
          url: "sales/index",
          menus: null,
        },
        {
          menuid: 2,
          icon: "el-icon-s-data",
          menuname: "数据中心",
          hasThird: null,
          url: null,
          menus: [
            {
              menuid: 21,
              icon: "",
              menuname: "批次统计",
              hasThird: "N",
              url: "sales/salesBatchStatistics",
              menus: null,
            },
            {
              menuid: 22,
              icon: "",
              menuname: "商户统计",
              hasThird: "N",
              url: "sales/salesMerchantStatistics",
              menus: null,
            },
            {
              menuid: 24,
              icon: "",
              menuname: "月度流水",
              hasThird: "N",
              url: "sales/allCustomersMonthlyFlow",
              menus: null,
            },
            {
              menuid: 25,
              icon: "",
              menuname: "新增流水",
              hasThird: "N",
              url: "sales/startStatistics",
              menus: null,
            },
          ],
        },
        {
          menuid: 3,
          icon: "el-icon-s-custom",
          menuname: "商户管理",
          hasThird: null,
          url: null,
          menus: [
            {
              menuid: 31,
              icon: "",
              menuname: "商户列表",
              hasThird: "N",
              url: "sales/merchantList",
              menus: null,
            },
            {
              menuid: 32,
              icon: "",
              menuname: "签单表",
              hasThird: "N",
              url: "sales/customerSignOrder",
              menus: null,
            },
          ],
        },
        {
          menuid: 4,
          icon: "el-icon-s-check",
          menuname: "财务中心",
          hasThird: true,
          url: null,
          menus: [
            {
              menuid: 41,
              icon: "",
              menuname: "余额管理",
              hasThird: "N",
              url: "payCenter/balance",
              menus: null,
            },
            {
              menuid: 42,
              icon: "",
              menuname: "开票记录",
              hasThird: "N",
              url: "payCenter/invoiceRecord",
              menus: null,
            },
          ],
        },
        {
          menuid: 5,
          icon: "el-icon-s-order",
          menuname: "用工中心",
          hasThird: true,
          url: null,
          menus: [
            {
              menuid: 51,
              icon: "",
              menuname: "用工结算明细",
              hasThird: "N",
              url: "task/employmentStatementDesc",
              menus: null,
            },
          ],
        },
      ],
      msg: "success",
    };

    // 运营
    let oms = {
      success: true,
      data: [
        {
          menuid: 1,
          icon: "el-icon-s-order",
          menuname: "签单管理",
          hasThird: null,
          url: null,
          menus: [
            {
              menuid: 11,
              icon: "",
              menuname: "签单表",
              hasThird: "N",
              url: "oms/customerSignOrder",
              menus: null,
            },
          ],
        },
        {
          menuid: 2,
          icon: "el-icon-bell",
          menuname: "消息管理",
          hasThird: null,
          url: null,
          menus: [
            {
              menuid: 21,
              icon: "",
              menuname: "发布消息",
              hasThird: "N",
              url: "oms/noticeManage",
              menus: null,
            },
          ],
        },
        {
          menuid: 3,
          icon: "el-icon-s-check",
          menuname: "白名单管理",
          hasThird: null,
          url: null,
          menus: [
            {
              menuid: 31,
              icon: "",
              menuname: "自由职业者白名单",
              hasThird: "N",
              url: "oms/whitelistList",
              menus: null,
            },
          ],
        },
        {
          menuid: 4,
          icon: "el-icon-s-grid",
          menuname: "任务管理",
          hasThird: null,
          url: null,
          menus: [
            {
              menuid: 41,
              icon: "",
              menuname: "任务列表",
              hasThird: "N",
              url: "oms/taskList",
              menus: null,
            },
          ],
        },
        {
          menuid: 5,
          icon: "el-icon-refresh",
          menuname: "商户同步",
          hasThird: null,
          url: null,
          menus: [
            {
              menuid: 51,
              icon: "",
              menuname: "同步商户信息",
              hasThird: "N",
              url: "oms/merchantSync",
              menus: null,
            },
          ],
        },
        {
          menuid: 6,
          icon: "el-icon-user",
          menuname: "自由职业者管理",
          hasThird: null,
          url: null,
          menus: [
            {
              menuid: 61,
              icon: "",
              menuname: "自由职业者列表",
              hasThird: "N",
              url: "oms/freelancerList",
              menus: null,
            },
          ],
        },
        {
          menuid: 7,
          icon: "el-icon-connection",
          menuname: "OpenApi",
          hasThird: null,
          url: null,
          menus: [
            {
              menuid: 71,
              icon: "",
              menuname: "对接客户",
              hasThird: "N",
              url: "oms/openapiClientList",
              menus: null,
            },
          ],
        },
        {
          menuid: 8,
          icon: "el-icon-sort",
          menuname: "商户转移管理",
          hasThird: null,
          url: null,
          menus: [
            {
              menuid: 81,
              icon: "",
              menuname: "客户转移",
              hasThird: "N",
              url: "oms/merchantTransfer",
              menus: null,
            },
          ],
        },
        {
          menuid: 9,
          icon: "el-icon-s-opportunity",
          menuname: "OEM贴牌",
          hasThird: null,
          url: null,
          menus: [
            {
              menuid: 91,
              icon: "",
              menuname: "品牌管理",
              hasThird: "N",
              url: "oms/oemBrandManage",
              menus: null,
            },
          ],
        },
        {
          menuid: 10,
          icon: "el-icon-s-cooperation",
          menuname: "提成比例设置",
          hasThird: null,
          url: null,
          menus: [
            {
              menuid: 101,
              icon: "",
              menuname: "销售比例设置",
              hasThird: "N",
              url: "oms/salesRatioSetting",
              menus: null,
            },
            {
              menuid: 102,
              icon: "",
              menuname: "主管比例设置",
              hasThird: "N",
              url: "oms/leaderRatioSetting",
              menus: null,
            },
            {
              menuid: 103,
              icon: "",
              menuname: "其他比例设置",
              hasThird: "N",
              url: "oms/otherRatioSetting",
              menus: null,
            },
          ],
        },
        {
          menuid: 11,
          icon: "el-icon-upload2",
          menuname: "其他途径批次",
          hasThird: null,
          url: null,
          menus: [
            {
              menuid: 111,
              icon: "",
              menuname: "其他途径批次导入",
              hasThird: "N",
              url: "oms/otherChannelBatch",
              menus: null,
            },
          ],
        },
      ],
      msg: "success",
    };

    // 管理员 角色1
    let admin = {
      success: true,
      data: [
        {
          menuid: 1,
          icon: "el-icon-s-opportunity",
          menuname: "OEM贴牌",
          hasThird: null,
          url: null,
          menus: [
            {
              menuid: 11,
              icon: "",
              menuname: "品牌管理",
              hasThird: "N",
              url: "oms/oemBrandManage",
              menus: null,
            },
          ],
        },
        {
          menuid: 2,
          icon: "el-icon-setting",
          menuname: "系统管理",
          hasThird: null,
          url: null,
          menus: [
            {
              menuid: 21,
              icon: "",
              menuname: "用户管理",
              hasThird: "N",
              url: "system/user",
              menus: null,
            },
            {
              menuid: 22,
              icon: "",
              menuname: "角色管理",
              hasThird: "N",
              url: "system/Role",
              menus: null,
            },
            {
              menuid: 23,
              icon: "",
              menuname: "菜单管理",
              hasThird: "N",
              url: "system/Module",
              menus: null,
            },
            {
              menuid: 24,
              icon: "",
              menuname: "公司管理",
              hasThird: "N",
              url: "system/Dept",
              menus: null,
            },
            {
              menuid: 25,
              icon: "",
              menuname: "系统变量",
              hasThird: "N",
              url: "system/Variable",
              menus: null,
            },
          ],
        },
        // 2026-08-27 用户需求: 提成设置/其他途径批次 从「商户转移管理」拆出, 升级为独立可展开菜单。
        
      ],
      msg: "success",
    };

    // 销售主管 角色6
    let salesSupervisor = {
      success: true,
      data: [
        {
          menuid: 1,
          icon: "el-icon-s-home",
          menuname: "首页",
          hasThird: null,
          url: "salesSupervisor/index",
          menus: null,
        },
        {
          menuid: 2,
          icon: "el-icon-s-custom",
          menuname: "团队管理",
          hasThird: null,
          url: null,
          menus: [
            {
              menuid: 21,
              icon: "",
              menuname: "销售列表",
              hasThird: "N",
              url: "salesSupervisor/teamList",
              menus: null,
            },
          ],
        },
        {
          menuid: 3,
          icon: "el-icon-s-shop",
          menuname: "商户管理",
          hasThird: null,
          url: null,
          menus: [
            {
              menuid: 31,
              icon: "",
              menuname: "商户列表",
              hasThird: "N",
              url: "salesSupervisor/merchantList",
              menus: null,
            },
          ],
        },
        {
          menuid: 4,
          icon: "el-icon-s-data",
          menuname: "数据中心",
          hasThird: null,
          url: null,
          menus: [
            {
              menuid: 41,
              icon: "",
              menuname: "批次统计",
              hasThird: "N",
              url: "salesSupervisor/salesBatchStatistics",
              menus: null,
            },
            {
              menuid: 42,
              icon: "",
              menuname: "月度流水",
              hasThird: "N",
              url: "salesSupervisor/monthlyFlow",
              menus: null,
            },
            {
              menuid: 43,
              icon: "",
              menuname: "月度毛利",
              hasThird: "N",
              url: "salesSupervisor/monthlyGrossProfit",
              menus: null,
            },
            {
              menuid: 44,
              icon: "",
              menuname: "月度签约",
              hasThird: "N",
              url: "salesSupervisor/monthlySignCount",
              menus: null,
            },
            {
              menuid: 45,
              icon: "",
              menuname: "新增流水",
              hasThird: "N",
              url: "salesSupervisor/startStatistics",
              menus: null,
            },
          ],
        },
      ],
      msg: "success",
    };

    if (user.roleId == 1) {
      // 管理员
      this.allmenu = admin.data;
      this.$root.Bus.$on("toggle", (value) => {
        this.collapsed = !value;
      });
    } else if (user.roleId == 2) {
      // 风控
      this.allmenu = riskContro.data;
      this.$root.Bus.$on("toggle", (value) => {
        this.collapsed = !value;
      });
    } else if (user.roleId == 3) {
      this.allmenu = agent.data;
      this.$root.Bus.$on("toggle", (value) => {
        this.collapsed = !value;
      });
    } else if (user.roleId == 4) {
      this.allmenu = sales.data;
      this.$root.Bus.$on("toggle", (value) => {
        this.collapsed = !value;
      });
    } else if (user.roleId == 5) {
      this.allmenu = oms.data;
      this.$root.Bus.$on("toggle", (value) => {
        this.collapsed = !value;
      });
    } else if (user.roleId == 6) {
      this.allmenu = salesSupervisor.data;
      this.$root.Bus.$on("toggle", (value) => {
        this.collapsed = !value;
      });
    } else {
      // 普通商户
      this.allmenu = res.data;
      this.$root.Bus.$on("toggle", (value) => {
        this.collapsed = !value;
      });

      if (
        this.$route.path == "/payCenter/applybilling" ||
        this.$route.path == "/payCenter/invoiceDetail"
      ) {
        this.activeRoute = "/payCenter/billingRecordList";
      }
      if (this.$route.path == "/task/employmentStatementDetail") {
        this.activeRoute = "/task/employmentStatement";
      }
    }
  },
  methods: {},
  computed: {
    brand() {
      return this.$store.state.brand;
    },
    brandImageUrl() {
      return this.brand.logoUrl || this.brand.faviconUrl || '';
    },
    isFaviconOnly() {
      return !this.brand.logoUrl && !!this.brand.faviconUrl;
    },
    showBrandWithName() {
      return !!(this.brandImageUrl && this.brand.systemName);
    },
    filteredMenuItems() {
      return this.allmenu.filter((menu) => menu.menus === null);
    },
    filteredSubmenus() {
      return this.allmenu.filter((menu) => menu.menus !== null);
    },
  },
};
</script>
<style>
.el-menu-vertical-demo:not(.el-menu--collapse) {
  width: 240px;
  min-height: 400px;
  border: none;
  padding-top: 0;
}
.el-menu-vertical-demo:not(.el-menu--collapse) {
  text-align: left;
}
.el-menu-item-group__title {
  padding: 0px;
}
.el-menu-bg {
  background-color: #fff !important;
}
.el-menu {
  border: none;
}
.logobox {
  box-sizing: border-box;
  height: 60px;
  min-height: 60px;
  max-height: 60px;
  color: #9d9d9d;
  font-size: 20px;
  text-align: center;
  background: #fff;
  padding: 0 10px;
  margin: 0;
  border-bottom: 1px solid #ccc;
  box-shadow: 0px 4px 15px 0px rgba(92, 133, 168, 0.1);
  position: relative;
  z-index: 2;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  flex-shrink: 0;
}
.brand-row {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  max-width: 100%;
  min-width: 0;
}
.logoimg {
  height: 40px;
  width: auto;
  max-width: 100%;
  object-fit: contain;
  flex-shrink: 0;
  display: block;
}
.logoimg.brand-favicon {
  width: 32px;
  height: 32px;
}
.logobox--with-name {
  justify-content: flex-start;
}
.logobox--with-name .brand-row .logoimg {
  height: 32px;
  max-width: 56px;
}
.logobox--with-name .brand-row .logoimg.brand-favicon {
  width: 28px;
  height: 28px;
  max-width: 28px;
}
.logobox .system-name {
  font-size: 14px;
  font-weight: 500;
  color: #303133;
  line-height: 32px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  flex: 0 1 auto;
  min-width: 0;
}
.logobox .system-name--only {
  line-height: 40px;
}
.el-menu-item:hover,
.el-submenu__title:hover,
.el-menu-item.is-active {
  outline: 0;
  color: #2772c7 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/leftnav.vue